import { render, staticRenderFns } from "./platformB.vue?vue&type=template&id=c9bdf55a&scoped=true&"
import script from "./platformB.vue?vue&type=script&lang=js&"
export * from "./platformB.vue?vue&type=script&lang=js&"
import style0 from "./platformB.vue?vue&type=style&index=0&id=c9bdf55a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9bdf55a",
  null
  
)

export default component.exports